const WEEKDAYS = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

export function parseDate(iso: string): Date {
  return new Date(iso);
}

export function toDateKey(iso: string): string {
  return iso.slice(0, 10);
}

export function formatDateCN(iso: string): string {
  const d = parseDate(iso);
  return `${d.getMonth() + 1}月${d.getDate()}日`;
}

export function formatWeekday(iso: string): string {
  const d = parseDate(iso);
  return WEEKDAYS[d.getDay()];
}

export function formatFullDateCN(iso: string): string {
  const d = parseDate(iso);
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
}

export function formatTime(iso: string): string {
  const d = parseDate(iso);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
}

export function formatDateTimeCN(iso: string): string {
  return `${formatDateCN(iso)} ${formatWeekday(iso)} ${formatTime(iso)}`;
}

export function formatNewsTime(iso: string): string {
  const d = parseDate(iso);
  return `${d.getMonth() + 1}-${String(d.getDate()).padStart(2, "0")} ${formatTime(iso)}`;
}

export function formatViewers(n: number): string {
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1)} 万`;
  }
  return `${n}`;
}

export function statusText(status: string): string {
  if (status === "live") return "直播中";
  if (status === "finished") return "已结束";
  return "未开始";
}

export function relativeDayLabel(dateKey: string): string {
  const today = "2026-10-12";
  const diff = Math.round(
    (new Date(`${dateKey}T00:00:00`).getTime() - new Date(`${today}T00:00:00`).getTime()) / 86400000
  );
  if (diff === 0) return "今日";
  if (diff === 1) return "明日";
  if (diff === -1) return "昨日";
  if (diff > 1 && diff <= 7) return "未来一周";
  return "";
}